import appContent from '@/services/content/appContent';
import log from '@/services/logger/log';

export const getRegistrationErrorContent = (statusCode, messageValue) => {
    const errors = appContent.getRegistrationErrorsContent();

    if (!errors || !Array.isArray(errors)) {
        log.warn('Registration errors content is not available or invalid');
        return {};
    }

    const isFullMatch = (error) =>
        error.responseStatusCode === statusCode && error.responseMessageValue === messageValue;
    const fullMatchError = errors.find(isFullMatch);

    if (fullMatchError) return fullMatchError;

    const isPartialMatch = (error) =>
        (error.responseStatusCode === statusCode && !error.responseMessageValue) ||
        (!error.responseStatusCode && error.responseMessageValue === messageValue);
    const partialMatchError = errors.find(isPartialMatch);

    if (partialMatchError) return partialMatchError;

    const isDefaultError = (error) => !error.responseStatusCode && !error.responseMessageValue;
    const defaultError = errors.find(isDefaultError);

    return defaultError || {};
};
